import { ModuleFetcher, SiteAssetsHttpClient } from '@wix/thunderbolt-becky-types'

import { componentsMappers } from '@wix/thunderbolt-components-native'
import { ILibraryTopology, createComponentsRegistrySiteAssets } from '@wix/thunderbolt-components-registry/siteAssets'

import { BeckyModel } from '../../types/becky'
import { getEditorElementsAssetUrl } from '../utils/assetsUrl'

const getTbElementsModule = async ({
	moduleFetcher,
	tbElementsSiteAssets,
	fileRepoUrl,
}: {
	moduleFetcher?: ModuleFetcher
	tbElementsSiteAssets?: string
	fileRepoUrl: string
}) => {
	if (!tbElementsSiteAssets || tbElementsSiteAssets === 'undefined' || !moduleFetcher) {
		return undefined
	}
	const fromUrl = getEditorElementsAssetUrl(tbElementsSiteAssets, fileRepoUrl)
	return moduleFetcher.fetch({ fromUrl })
}

export const getComponentMappers = async ({
	moduleFetcher,
	httpClient,
	tbElementsSiteAssets,
	fileRepoUrl,
	experiments,
	registryLibrariesTopology,
}: {
	httpClient: SiteAssetsHttpClient
	moduleFetcher?: ModuleFetcher
	tbElementsSiteAssets?: string
	fileRepoUrl: string
	experiments: BeckyModel['experiments']
	registryLibrariesTopology: string
}) => {
	if (!experiments['specs.thunderbolt.editor_elements_site_assets']) {
		return componentsMappers
	}

	if (experiments['specs.thunderbolt.componentsRegistry']) {
		const libraries: Array<ILibraryTopology> = JSON.parse(registryLibrariesTopology)

		const registry = await createComponentsRegistrySiteAssets({
			libraries,
			modulesLoader: {
				relativeUrl: () => {
					throw new Error('ModulesLoader `relativeUrl` method should not be used')
				},
				absoluteUrl: async (url) => {
					const response = await httpClient.fetch(url)
					return response.text() as any
				},
			},
		})

		const models = await registry.loadComponentMappers()

		return {
			...componentsMappers,
			...models,
		}
	} else {
		const module = await getTbElementsModule({ moduleFetcher, tbElementsSiteAssets, fileRepoUrl })
		const tbElementsMappers = module?.default ?? module
		return { ...componentsMappers, ...tbElementsMappers }
	}
}
